import React, { useEffect, useState } from 'react'
import OurSlider from '../Components/slider/OurSlider';
import EventSlider from '../Components/slider/EventSlider';
import FeedSlider from '../Components/slider/FeedSlider';
import { addToLike, getAllPost, getAllProject, getDonation, getGallery, removeToLike } from '../Common/apis';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import moment from 'moment';
import Loader from '../Components/Loader/Loader';

function Home() {
    const [gallery, setGallery] = useState(null);
    const [allPost, setAllPost] = useState(null)
    const [allProject, setAllProject] = useState(null)
    const [loading, setLoading] = useState(false);
    const [donation, setDonation] = useState(null)
    const user = JSON.parse(localStorage.getItem("USER"));
    const userId = user?._id;

    const HandleLike = async (id) => {
        setLoading(true);
        try {
            const response = await addToLike(id);
            toast.success(response.message)
            if (response) {
                fetchPosts();
            }
        } catch (error) {
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    }
    const HandleUnlike = async (id) => {
        setLoading(true);
        try {
            const response = await removeToLike(id);
            toast.success(response.message)
            if (response) {
                fetchPosts();
            }
        } catch (error) {
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    }


    const fetchDonation = async () => {
        setLoading(true);
        try {
            const response = await getDonation();
            setDonation(response.data);
        } catch (error) {
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    };

    const fetchProject = async () => {
        setLoading(true);
        try {
            const response = await getAllProject();
            setAllProject(response.data);
        } catch (error) {
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    };
    const fetchPosts = async () => {
        setLoading(true);
        try {
            const response = await getAllPost();
            setAllPost(response.data);
        } catch (error) {
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    };

    const fetchGallery = async () => {
        setLoading(true);
        try {
            const response = await getGallery();
            setGallery(response.data);
        } catch (error) {
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchGallery();
        fetchPosts();
        fetchProject();
        fetchDonation();
    }, []);

    return (
        <>
            {loading && <Loader />}
            <section className='hero-section relative mt-[80px] overflow-hidden'>
                <div className="absolute bottom-[33px] left-[50%] translate-x-[-50%]">
                    <h2 className="max-w-[673px] w-full font-[700] font-manrope md:text-[34px] text-[20px] pb-[26px] text-center text-[#FFFFFF]">“No One Saves us But Ourselves We Ourselves Must Walk The Path”</h2>
                    <div className="flex flex-col items-center gap-[36px]">
                        <button className='d-btn'>Donate</button>
                        <img src="/assets/home/drop-down.svg" alt="" />
                    </div>
                </div>
                <div className="absolute bottom-[200px] left-[-176px] rotate-[-90deg] flex gap-[24px] items-center">
                    <div className='w-[37px] h-[4px] bg-[#FFFFFF]'>
                    </div>
                    <p style={{ letterSpacing: "10px" }} className="font-[600] font-poppins text-[20px] text-[#FFFFFF]">NASRSINGH TEMPLE</p>
                </div>
            </section>
            <section className="about-section md:pt-[113px] pt-[50px] md:pb-[146px] pb-[50px] md:px-[120px] px-[20px]">
                <div className='flex lg:gap-[106px] gap-[40px] lg:flex-row flex-col items-center'>
                    <div>
                        <img src="/assets/home/img1.png" alt="" />
                    </div>
                    <div>
                        <p className="text-primary-orange pb-[8px]">ABOUT US</p>
                        <h6 className="max-w-[634px] w-full text-heading-primary md:pb-[34px] pb-[20px] text-[#2D190D]">Before Visiting the Temple Learn <span className='text-[#FF6000]'>Dharma Protocol</span></h6>
                        <p className="max-w-[588px] w-full font-[500] text-[16px] font-manrope leading-[34px] text-[#000000] tracking-[2px] pb-[50px]">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper.</p>
                        <button className='d-btn'>READ MORE</button>
                    </div>
                </div>
            </section>
            <section className='lg:pt-[100px] pt-[50px] overflow-hidden'>
                <p className="text-primary-orange text-center">DONATION</p>
                <h6 className="text-center text-heading-primary text-[#2D190D] pb-[80px]">Our <span className='text-[#FF6000]'>Donation</span></h6>
                <div className='our-slider'>
                    <OurSlider donation={donation} />
                </div>
            </section>
            <section className='md:pt-[100px] pt-[50px] overflow-hidden'>
                <p className="text-primary-orange text-center">EVENTS</p>
                <h6 className="text-center text-heading-primary text-[#2D190D] pb-[80px]">Upcoming <span className='text-[#FF6000]'>Events</span></h6>
                <div className='our-slider md:px-[75px] px-[20px]'>
                    <EventSlider />
                </div>
            </section>
            <section className='lg:pt-[100px] pt-[50px] overflow-hidden'>
                <div className='bg-[#FFFFFF]' style={{ backdropFilter: "blur(144px)" }}>
                    <p className="text-primary-orange text-center">Feeds</p>
                    <h6 className="text-center text-heading-primary text-[#2D190D]">Community <span className='text-[#FF6000]'>Feeds</span></h6>
                </div>
                <div className='feed-slider pt-[122px] pb-[144px]'>
                    {allPost?.length > 3 ? <FeedSlider allPost={allPost} /> : <div className="grid grid-cols-1 gap-[30px] max-w-[654px] mx-auto w-full">
                        {allPost?.map((e, i) => {
                            const isLiked = e.Likes.some((like) => like._id === userId);
                            return (
                                <div key={i} className='bg-[#FFFFFF] pt-[21px] pb-[16px] px-[20px] rounded-[20px]' style={{ boxShadow: "0px 4px 29px 0px #00000014" }}>
                                    <div className="flex pb-[10px] justify-between items-center">
                                        <div className="flex items-center gap-[5px]">
                                            <img src={e?.Image} className='h-[40px] w-[40px] rounded-full' alt="" />
                                            <div>
                                                <h6 className="font-[700] text-[14px] font-manrope text-[#000000] tracking-[-0.3px] pb-[4px]">{e?.UserName}</h6>
                                                <p className="font-[700] font-manrope text-[12px] text-[#747575] tracking-[-0.3px]">{e?.Location}</p>
                                            </div>
                                        </div>
                                        <button>
                                            <img src="/assets/home/horizon.svg" alt="" />
                                        </button>
                                    </div>
                                    <div className='relative'>
                                        <img src={e?.Images[1]} className='w-full pb-[10px]' alt="" />
                                        <div className="flex flex-col items-center gap-[24px] absolute bottom-[10px] right-[10px] ">
                                            {/* <button>
                                                    <img src="/assets/nav/share.svg" alt="" />
                                                </button>
                                                <button className='gap-[8px] px-[15px] pt-[18px] flex flex-col items-center'>
                                                    <img src="/assets/nav/comment.svg" alt="" />
                                                    <p className="font-[500] font-manrope text-[14px] text-[#FFFFFF]">273</p>
                                                </button> */}
                                            <div className='bg-[#FF6000] rounded-full gap-[8px] px-[15px] py-[18px] flex flex-col items-center'>
                                                {isLiked ?
                                                    <button onClick={() => HandleUnlike(e?._id)}>
                                                        <img src="/assets/nav/like.svg" alt="" />
                                                    </button>
                                                    :
                                                    <button onClick={() => HandleLike(e?._id)}>
                                                        <img src="/assets/nav/like.svg" alt="" />
                                                    </button>
                                                }
                                                <p className="font-[500] font-manrope text-[14px] text-[#FFFFFF]">{e?.Likes.length}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="bg-[#F6F8FA] rounded-[8px] py-[12px] px-[14px] flex justify-between items-center">
                                        <div className='flex gap-[16px] items-center'>
                                            <img src="/assets/home/commenter.png" alt="" />
                                            <input type="text" className='border-none bg-transparent' placeholder='Add a comment...' />
                                        </div>
                                        <p className="font-[400] text-[10px] font-manrope leading-[26px] text-[#000000] tracking-[0.5px]">(273 Comments)</p>
                                    </div>
                                </div>
                            )
                        })}
                    </div>}
                </div>
            </section>
            <section className='md:pt-[100px] pt-[500] md:pb-[78px] pb-[50px] overflow-hidden'>
                <p className="text-primary-orange text-center">PROJECTS</p>
                <h6 className="text-center text-heading-primary text-[#2D190D] pb-[80px]">Our <span className='text-[#FF6000]'>Projects</span></h6>
                <div className="grid lg:grid-cols-4 grid-cols-1 lg:px-[75px] px-[30px] gap-[34px]">
                    {allProject && allProject.length > 0 ? (
                        allProject?.map((item) => (
                            <Link to={`/project/project-detail/${item?._id}`} key={item?._id}>
                                <div className="relative">
                                    <img src={item?.Image} className='w-full h-[372px] rounded-[16px]' alt="" />
                                    <div className="absolute inset-0 bg-black bg-opacity-40 rounded-[16px]"></div>
                                    <div className="px-[20px] absolute w-full bottom-[20px]">
                                        <h6 className="font-[700] text-[20px] font-manrope text-[#FFFFFF] pb-[9px]">
                                            {item?.ProjectName}
                                        </h6>
                                        <div className="flex justify-between w-full items-center">
                                            <div className="flex items-center gap-[8px]">
                                                <img className='h-[29px] object-cover w-[29px] rounded-full' src={item?.UserImage} alt="" />
                                                <p className="font-[400] font-manrope text-[16px] text-[#FFFFFF]">
                                                    {item?.UserName}
                                                </p>
                                            </div>
                                            <p className="font-[400] font-manrope text-[16px] text-[#FFFFFF]">
                                                {moment(item?.createdAt).format('D MMMM YYYY')}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        ))
                    ) : (
                        <p className="text-center text-[#000000] font-manrope text-[18px] py-10">
                            No projects found.
                        </p>
                    )}
                </div>
            </section>
            <section className='pt-[62px] gallery-section md:pb-[130px] pb-[40px] overflow-hidden'>
                <p className="text-primary-orange text-center">GALLERY</p>
                <h6 className="text-center text-heading-primary text-[#2D190D] pb-[80px]">Our <span className='text-[#FF6000]'>Gallery</span></h6>
                <div className='md:px-[75px] px-[20px] grid md:grid-rows-2 grid-rows-1 md:grid-cols-3 grid-cols-1 gap-[30px]'>
                    {gallery && gallery.length > 0 ? (
                        gallery.map((e, i) => (
                            <div key={i} className='row-span-2 relative group w-full overflow-hidden'>
                                <img src={e?.Image} className='w-full h-full' alt="" />
                                <div className="absolute inset-0 bg-black bg-opacity-70 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                    <img src="/assets/gallery/arrow-up.svg" alt="up-arrow" className="w-[50px] h-[50px]" />
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="text-center text-gray-500 py-10 col-span-full">
                            No images found in the gallery.
                        </div>
                    )}
                </div>
            </section>
        </>
    )
}

export default Home


